import TFS_Core_Ajax = require("Presentation/Scripts/TFS/TFS.Legacy.Ajax");
import Q = require("q");
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import { FeatureAvailabilityFlags } from "Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants";
import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import Service = require("VSS/Service");
import Contributions_Services = require("VSS/Contributions/Services");
import { WebAccessBoardsWITDataSource } from "Presentation/Scripts/TFS/MVCToDataProviderDataSources/MVCToDataProviderDataSource";

interface IMigrateJobStatusDataProviderRequestProperties {
    jobIdToQuery: string;
}

export function queryMigrateJobStatus(jobIdToQuery: string): IPromise<PromoteJobStatusResult> {
    const pageDataService = Service.getService(Contributions_Services.WebPageDataService);

    const requestProperties: IMigrateJobStatusDataProviderRequestProperties = {
        jobIdToQuery: jobIdToQuery
    };

    // Force a roundtrip
    return pageDataService.getDataAsync<string>(new WebAccessBoardsWITDataSource().MVCActionToDataproviderIdMapping['GetJobProgress'], null, requestProperties).then(data => {
        return JSON.parse(data) as PromoteJobStatusResult;
    });
}

// capitalized to match the return type from server
export interface PromoteJobStatusResult {
    State: number;
    PercentComplete?: number;
    ProgressText: string;
}
